export default "__VITE_PUBLIC_ASSET__e4c4abc4__"